import { Button, ButtonProps, SxProps, Tooltip } from "@mui/material";

interface Props extends ButtonProps {
  isActive?: boolean;
  extraSx?: SxProps;
}

export default function MenuButton(props: Props) {
  const { isActive, extraSx, children, title } = props;

  return (
    <Tooltip title={title} placement="top">
      <Button
        variant={isActive ? "contained" : "outlined"}
        size="large"
        sx={{
          width: "56px",
          color: isActive ? "common.white" : "text.primary",
          borderColor: "#ccc",
          borderRadius: "5px",
          p: 0.5,
          ...extraSx,
        }}
        {...props}
      >
        {children}
      </Button>
    </Tooltip>
  );
}
